import { useNavigate, useLocation } from "react-router-dom"

import Style from "./style"
import homeActive from "./asset/homeActive.svg"
import homeDeactive from "./asset/homeDeactive.svg"
import eventActive from "./asset/eventActive.svg"
import eventDeactive from "./asset/eventDeactive.svg"
import qrActive from "./asset/qrActive.svg"
import qrDeactive from "./asset/qrDeactive.svg"
import rankingActive from "./asset/rankingActive.svg"
import rankingDeactive from "./asset/rankingDeactive.svg"
import myActive from "./asset/myActive.svg"
import myDeactive from "./asset/myDeactive.svg"

import useLoginCookie from "shared/model/useLoginCookie"

const Footer = () => {
    const navigate = useNavigate()
    const location = useLocation()

    const [loginCookie] = useLoginCookie()

    const menuList = [
        {
            "label": "HOME",
            "active": homeActive,
            "deactive": homeDeactive,
            "url": "/"
        },
        {
            "label": "대회목록",
            "active": eventActive,
            "deactive": eventDeactive,
            "url": "/event"
        },
        {
            "label": "랭킹",
            "active": rankingActive,
            "deactive": rankingDeactive,
            "url": "/ranking"
        },
        {
            "label": "로그인",
            "active": myActive,
            "deactive": myDeactive,
            "url": "/login"
        },
    ]

    const loginMenuList = [
        {
            "label": "HOME",
            "active": homeActive,
            "deactive": homeDeactive,
            "url": "/"
        },
        {
            "label": "대회목록",
            "active": eventActive,
            "deactive": eventDeactive,
            "url": "/event"
        },
        {
            "label": "QR",
            "active": qrActive,
            "deactive": qrDeactive,
            "url": "/qr"
        },
        {
            "label": "랭킹",
            "active": rankingActive,
            "deactive": rankingDeactive,
            "url": "/ranking"
        },
        {
            "label": "마이페이지",
            "active": myActive,
            "deactive": myDeactive,
            "url": "/my"
        },
    ]

    const exceptionList = ["/find/id", "/find/password", "/signup", "/signup/sns"]

    const showMenu = loginCookie ? loginMenuList : menuList

    return (
        <>
            {!exceptionList.includes(location.pathname) &&
                <Style.Footer>
                    {showMenu?.map(elem =>
                        <Style.MenuElement onClick={() => navigate(elem.url, { "replace": true })} $active={location.pathname === elem.url}>
                            <img src={location.pathname === elem.url ? elem.active : elem.deactive} />
                            <p>{elem.label}</p>
                        </Style.MenuElement>
                    )}
                </Style.Footer>
            }
        </>
    )
}

export default Footer